import React from "react";

export const CloseIcon = ({
  width = "22",
  height = "22",
  fill = "none",
  stroke = "#89ab0d",
  strokeWidth = "1.5",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.061 22.061"
      {...{ width, height, fill }}
    >
      <g
        id="Group_32"
        data-name="Group 32"
        transform="translate(-5930.136 -549.136)"
      >
        <line
          id="Line_29"
          data-name="Line 29"
          x1="21.001"
          y2="21.001"
          transform="translate(5930.667 549.667)"
          fill="none"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
        <line
          id="Line_30"
          data-name="Line 30"
          x2="21.001"
          y2="21.001"
          transform="translate(5930.667 549.667)"
          fill="none"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
};
